{
  "hero": {
    "title": "حوّل كتالوج منتجاتك إلى",
    "subtitle": "مستشاري تسوق بالذكاء الاصطناعي",
    "description": "قم بنشر قوة مبيعات تفاعلية تبيع — وليس مجرد دردشة. على موقعك الإلكتروني، وسائل التواصل الاجتماعي، واتساب، وChatGPT.",
    "createAssistant": "إنشاء مساعد ذكاء اصطناعي",
    "bookDemo": "حجز عرض توضيحي"
  },
  "nav": {
    "solutions": "الحلول",
    "products": "المنتجات",
    "pricing": "الأسعار",
    "caseStudies": "دراسات الحالة",
    "blog": "المدونة",
    "contact": "اتصل بنا",
    "shoppingExpert": "خبير التسوق",
    "gptStore": "متجر GPT"
  },
  "chat": {
    "greeting": "مرحبًا! أنا مساعد التسوق بالذكاء الاصطناعي. جرّب سؤالي عن منتجات مثل التلفزيونات أو أجهزة الكمبيوتر المحمولة أو آلات صنع القهوة. كيف يمكنني مساعدتك اليوم؟",
    "placeholder": "اكتب رسالتك هنا...",
    "contact": {
      "heading": "يرجى مشاركة معلومات الاتصال الخاصة بك"
    }
  },
  "sections": {
    "partners": {
      "title": "موثوق به من قبل المنصات الرائدة"
    },
    "gptPromo": {
      "title": "أطلق علامتك التجارية في متجر GPT",
      "description": "أنشئ مساعد تسوق GPT مخصص يعرض منتجاتك ويحول المتصفحين إلى مشترين."
    },
    "solutions": {
      "title": "حلول الصناعة",
      "subtitle": "مستشارو تسوق بالذكاء الاصطناعي مصممون لصناعتك",
      "electronics": {
        "title": "الإلكترونيات والتكنولوجيا",
        "description": "ساعد العملاء على التنقل بين المواصفات التقنية المعقدة والعثور على الجهاز المثالي.",
        "items": [
          "مقارنات ذكية للمنتجات",
          "مطابقة المواصفات التقنية",
          "التحقق من التوافق",
          "توصيات الأداء"
        ]
      },
      "fashion": {
        "title": "الأزياء والملابس",
        "description": "قدم نصائح تنسيق مخصصة وتوصيات المقاسات.",
        "items": [
          "مطابقة الأنماط والتوصيات",
          "إرشادات المقاس والملاءمة",
          "نصائح اتجاهات الموسم",
          "تنسيق الملابس"
        ]
      },
      "home": {
        "title": "المنزل والحديقة",
        "description": "توجيه العملاء خلال قرارات تحسين المنزل والديكور.",
        "items": [
          "استشارة تصميم الغرف",
          "توصيات الأجهزة",
          "نصائح تحسين المساحة",
          "إرشادات الصيانة"
        ]
      },
      "agency": {
        "title": "الوكالات والشركاء",
        "description": "حلول العلامة البيضاء للوكالات التي تخدم عدة عملاء في مجال البيع بالتجزئة.",
        "items": [
          "إدارة متعددة العملاء",
          "خيارات العلامة التجارية المخصصة",
          "التحليلات والتقارير",
          "دعم شركاء الوكالة"
        ]
      }
    },
    "platforms": {
      "title": "المنصة المدعومة"
    },
    "valueProps": {
      "title": "لماذا تختار Shopilots؟",
      "subtitle": "حوّل تجربة البيع بالتجزئة الخاصة بك مع ذكاء اصطناعي يبيع فعلاً",
      "conversion": {
        "title": "زيادة التحويلات",
        "description": "حوّل المتصفحين إلى مشترين مع توصيات منتجات مخصصة وتجارب تسوق موجهة.",
        "metric": "معدل التحويل"
      },
      "aov": {
        "title": "زيادة متوسط قيمة الطلب",
        "description": "اقتراحات ذكية للبيع المتصاعد والمتقاطع تبدو طبيعية ومفيدة للعملاء.",
        "metric": "متوسط قيمة الطلب"
      },
      "returns": {
        "title": "تقليل المرتجعات",
        "description": "مطابقة أفضل للمنتجات تعني أن العملاء يحصلون على ما يحتاجونه بالضبط من أول مرة.",
        "metric": "معدل الإرجاع"
      },
      "advantage": {
        "title": "ميزة Shopilots",
        "description": "على عكس روبوتات الدردشة العامة، يفهم ذكاؤنا الاصطناعي منتجاتك ويتحدث بصوت علامتك التجارية.",
        "features": {
          "catalog": "تكامل الكتالوج في الوقت الفعلي",
          "sales": "محادثات تركز على المبيعات",
          "channels": "نشر متعدد القنوات",
          "analytics": "تحليلات تركز على الإيرادات"
        }
      },
      "testimonial": {
        "title": "نجاح العملاء",
        "quote": "قامت Shopilots بتحويل مبيعاتنا عبر الإنترنت. يجد العملاء المنتجات بشكل أسرع ويشترون بثقة أكبر.",
        "name": "سارة جونسون",
        "position": "مديرة التجارة الإلكترونية"
      }
    }
  },
  "micro": {
    "demoMode": "وضع العرض التوضيحي"
  },
  "forms": {
    "name": "الاسم",
    "email": "البريد الإلكتروني",
    "company": "الشركة",
    "phone": "الهاتف",
    "optional": "اختياري",
    "thankYou": "شكراً لك!"
  },
  "buttons": {
    "sending": "جارِ الإرسال...",
    "submit": "إرسال",
    "launchAssistant": "أطلق مساعد الذكاء الاصطناعي الخاص بك",
    "callUs": "اتصل بنا",
    "learnMore": "اعرف المزيد",
    "getStarted": "ابدأ الآن",
    "findSolution": "ابحث عن حلك"
  },
  "footer": {
    "description": "مستشارو تسوق بالذكاء الاصطناعي يبيعون — وليس مجرد دردشة. قم بالنشر على موقعك الإلكتروني، وسائل التواصل الاجتماعي، واتساب، وChatGPT.",
    "solutions": "الحلول",
    "resources": "الموارد",
    "contactUs": "اتصل بنا",
    "copyright": "جميع الحقوق محفوظة.",
    "links": {
      "privacyPolicy": "سياسة الخصوصية",
      "termsOfService": "شروط الخدمة",
      "sitemap": "خريطة الموقع"
    }
  }
}